import Vue from 'vue';
import Injector from 'vue-inject';
import Debug from '@/util/debug';

const debug = Debug('service:ApiKey');

const PERSISTENCE_KEY = 'adapi:key';
const PRESISTENDE_DURATION = '30D'; // 30 days

export default class ApiKeyService {
  constructor(vue) {
    this.vue = vue;
    this.apiKey = null;
    this.eventBus = new Vue();
  }

  setKey(key) {
    debug.info('new key: %s %o', key ? `${key.substr(0, 20)}...` : null, { key });
    this.apiKey = key;
    this.eventBus.$emit('changedApiKey');
  }

  getKey() {
    return this.apiKey;
  }

  toPersistance(key, remember = false) {
    if (!key) {
      return this.vue.$cookie.delete(PERSISTENCE_KEY);
    }

    const options = {};
    if (remember) {
      options.expires = PRESISTENDE_DURATION;
    }
    return this.vue.$cookie.set(PERSISTENCE_KEY, key, options);
  }

  fromPersistance() {
    return this.vue.$cookie.get(PERSISTENCE_KEY) || null;
  }

  getEventBus() {
    return this.eventBus;
  }
}

Injector.service('apiKeyService', ['$context'], ApiKeyService);



// WEBPACK FOOTER //
// ./src/services/ApiKeyService.js